import {
  numericKeyDownHandler,
  positiveIntegerInputHandler,
} from 'module/helpers/input-number-event-handlers';
import {
  EstimateFieldFilter,
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from 'module/types/filter-field/filter/estimate';
import { Menu } from 'module/ui/components/atoms/dropdown';
import { InputNumber } from 'module/ui/components/atoms/input/input-number';
import { Radio } from 'module/ui/components/atoms/radio';
import { snakeCase } from 'lodash';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CriteriaSelect } from '../criteria-select';
import { Line, Lines } from './components';

const DaysInput = styled(InputNumber)`
  padding-left: var(--spacing-02);
  min-width: 64px;
  max-width: 64px;
  margin-right: var(--spacing-03);

  input {
    text-align: right;
    padding-right: var(--spacing-04);
  }
`;

export const renderRelativeMenuItem = (
  filter: EstimateFieldFilter,
  type: EstimateFieldFilterOperationType,
  onChange: (filter: EstimateFieldFilter) => void,
) => (
  <Menu.Item key={type.toString()} className="date-criteria">
    <Lines>
      <Line>
        <Radio checked={filter.type === type} />{' '}
        <FormattedMessage
          id={`task_list.filters.${snakeCase(
            EstimateFieldFilterOperationType[type],
          )}`}
        />
      </Line>
      {filter.type === type && (
        <Line>
          <DaysInput
            className="date-criteria"
            autoFocus
            min={0}
            max={1095}
            value={(filter as EstimateFieldFilter).days}
            onKeyDown={numericKeyDownHandler()}
            onInput={() => positiveIntegerInputHandler(0, 1095)}
            onChange={(value) =>
              onChange({
                ...filter,
                days:
                  value == null || value.toString().trim().length === 0
                    ? undefined
                    : parseInt(value.toString(), 10),
              } as EstimateFieldFilter)
            }
          />
          <FormattedMessage id="task_list.filters.days" />
          <CriteriaSelect
            className="date-criteria"
            style={{ marginLeft: 'var(--spacing-03)' }}
            width={96}
            value={(filter as EstimateFieldFilter).direction}
            onChange={(value) =>
              onChange({ ...filter, direction: value } as EstimateFieldFilter)
            }
            options={[
              {
                label: 'Early',
                value: EstimateRelativeDirection.Early,
                content: <FormattedMessage id="task_list.filters.early" />,
              },
              {
                label: 'Late',
                value: EstimateRelativeDirection.Late,
                content: <FormattedMessage id="task_list.filters.late" />,
              },
            ]}
          />
        </Line>
      )}
    </Lines>
  </Menu.Item>
);
